/**
 * @generated SignedSource<<60e6f2bb9e1f85948db122874e256af6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderTitle_profile$data = {
  readonly age: number | null | undefined;
  readonly closestCity: string | null | undefined;
  readonly isVerified: boolean | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile">;
  readonly " $fragmentType": "ProfileHeaderTitle_profile";
};
export type ProfileHeaderTitle_profile$key = {
  readonly " $data"?: ProfileHeaderTitle_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileHeaderTitle_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHeaderTitle_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closestCity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileAvatar_profile"
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "45e940d47cfa28f97c587b81ab473b57";

export default node;
